import _ from 'lodash';

export default {
  methods: {
    transformErrorData(errorData) {
      const errors = _.get(errorData, 'errors', null);
      const errorObject = {};

      _.forEach(errors, (error) => {
        errorObject[error.field] = error.message;
      });

      return errorObject;
    },
    geErrorByName(errorResponse, fieldName) {
      return _.get(errorResponse, fieldName, null);
    },
    findKeyErrorByName(errorResponse, fieldName) {
      return _.some(errorResponse, (valueObject, key) => key.startsWith(fieldName) && _.some(valueObject, (value) => value));
    },
  },
};
